export enum GameResultCategory {
  POOR = 'POOR', // 0–20%
  AVERAGE = 'AVERAGE', // 20.1–60%
  GOOD = 'GOOD', // 60.1–99.99%
  EXCELLENT = 'EXCELLENT', // 100%
}
